// extracted by mini-css-extract-plugin
export default {"iframeContainer":"SpectacleDetailStream_iframeContainer__WmZSE"};